const decodeBase64Url = (value: string): string => {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/')
  const padding = '='.repeat((4 - (base64.length % 4)) % 4)

  return atob(`${base64}${padding}`)
}

const decodeJwtPayload = (token: string): { [key: string]: string } => {
  const parts = token.trim().split('.')

  if (parts.length !== 3 || !parts[1]) {
    throw new Error('Invalid JWT format')
  }

  const payload = JSON.parse(decodeBase64Url(parts[1])) as {
    [key: string]: string
  }

  return payload
}

export const decode = (token: string): { [key: string]: string } => {
  const jwt = token.split('Bearer')[1]?.trim()

  if (!jwt) {
    throw new Error('Invalid JWT format')
  }

  return decodeJwtPayload(jwt)
}

export const decodeWithoutBearer = (
  token: string
): { [key: string]: string } => decodeJwtPayload(token)
